
export const LEGAL_MORTGAGE_KEY_MAP = {
	'1': 'Carter Lemon Cameron’s LLP',
	'2': 'Healy\'s LLP',
	'3': 'JBL Solicitors',
	'4': 'Lester Dominic Solicitors',
	'5': 'Others'
};

export type SolicitorAndLTVType = keyof typeof LEGAL_MORTGAGE_KEY_MAP;